import { useState } from 'react';

import { Switch } from 'antd';

import { FormGroup } from '@/components/FormGroup';
import PreviewProduct from '@/components/wizard/PreviewProduct';
import useProductStore from '@/stores/productStore';

import ProducerData from './ProducerData';

export default function ProducerDataContainer() {
  const [collapsable, setCollapsable] = useState(true);
  const [validationState, setValidationState] = useState(true);
  const [reviewMode, setReviewMode] = useState(false);

  const product = useProductStore(d => d);

  return (
    <>
      <div className='m-2 flex flex-row gap-4 rounded-lg bg-orange-300 p-4'>
        <div>
          <Switch id='toggle-collapsable' checked={collapsable} onChange={v => setCollapsable(v)} />{' '}
          <span>Collapsable</span>
        </div>
        <div>
          <Switch id='toggle-validation-state' checked={validationState} onChange={v => setValidationState(v)} />{' '}
          <span>Validation State</span>
        </div>
        <div>
          <Switch id='toggle-preview-mode' checked={reviewMode} onChange={v => setReviewMode(v)} />{' '}
          <span>Preview Mode</span>
        </div>
      </div>

      <div className='flex flex-row gap-2'>
        <FormGroup collapsable={collapsable} showValidationState={validationState} reviewMode={reviewMode}>
          <ProducerData />
        </FormGroup>
        <div className='flex w-[600px] flex-col gap-2'>
          <PreviewProduct />
          <div>{product && <pre>{JSON.stringify(product, null, 2)}</pre>}</div>
        </div>
      </div>
    </>
  );
}
